import React, {useCallback, useContext, useEffect, useState} from 'react';
import { Container, Row, Col, Card, Button, Form, Tab, Tabs } from 'react-bootstrap';
import CreateGenre from "../../components/modals/genre/CreateGenre";
import EditBook from "../../components/modals/book/EditBook";
import EditUser from "../../components/modals/EditUser";
import {Context} from "../../index";
import {fetchAssTypes, fetchCurrentUserBooks, fetchGenre, fetchLanguages, fetchPrices} from "../../http/bookAPI";
import EditGenre from "../../components/modals/genre/EditGenre";
import DeleteGenre from "../../components/modals/genre/DeleteGenre";
import CreateLanguage from "../../components/modals/language/CreateLanguage";
import UpdateLanguage from "../../components/modals/language/UpdateLanguage";
import DeleteLanguage from "../../components/modals/language/DeleteLanguage";
import CreatePrice from "../../components/modals/price/CreatePrice";
import UpdatePrice from "../../components/modals/price/UpdatePrice";
import DeletePrice from "../../components/modals/price/DeletePrice";
import CreateAssignType from "../../components/modals/assignType/CreateAssignType";
import UpdateAssignType from "../../components/modals/assignType/UpdateAssignType";
import DeleteAssignType from "../../components/modals/assignType/DeleteAssignType";
import BookSearch from "../../components/admin/BookSearch";
import FinStat from "../../components/admin/FinStat";
import UpdateBookType from "../../components/modals/bookType/UpdateBookType";
import CreateBookType from "../../components/modals/bookType/CreateBookType";
import MaintenanceModal from "../../components/admin/MaintenanceModal";
import AssignmentSearch from "../../components/admin/AssignmentSearch";
import AffiliateCodeApprove from "../../components/admin/AffiliateCodeApprove";
import TestEmailSender from "../../components/admin/TestEmailSender";
import AdminVirtTransfersList from "../../components/admin/AdminVirtTransfersList";
import UserSearchAdmin from "../../components/admin/UserSearchAdmin";
import VirtSellOrdersAdmin from "../../components/admin/VirtSellOrdersAdmin";
import AffiliatePayoutsAdmin from "../../components/admin/AffiliatePayoutsAdmin";
import AdminUserLogs from "../../components/admin/AdminUserLogs";
import AdminPromoBounty from "../../components/admin/AdminPromoBounty";
import PublicPageEditorAdmin from "../../components/admin/PublicPageEditorAdmin";
import AdminRdpAccess from "../../components/admin/AdminRdpAccess";
import AdminDashboardPromotion from "../../components/admin/AdminDashboardPromotion";
import AdminAmazonAvailabilityAudit from "../../components/admin/AdminAmazonAvailabilityAudit";
import AdminInternalNews from "../../components/admin/AdminInternalNews";
import AdminPublicNews from "../../components/admin/AdminPublicNews";
import AdminReviewerProfileRequests from "../../components/admin/AdminReviewerProfileRequests";

const AdminDashboard = () => {
    const [addgenreVisible, setAddGenreVisible] = useState(false)
    const [editgenreVisible, setEditGenreVisible] = useState(false)
    const [delgenreVisible, setDelGenreVisible] = useState(false)

    const [addlanguageVisible, setAddLanguageVisible] = useState(false)
    const [updatelanguageVisible, setUpdateLanguageVisible] = useState(false)
    const [dellanguageVisible, setDelLanguageVisible] = useState(false)

    const [addpriceVisible, setAddPriceVisible] = useState(false)
    const [updatepriceVisible, setUpdatePriceVisible] = useState(false)
    const [delPriceVisible, setDelPriceVisible] = useState(false)

    const [addassignTypeVisible, setAddAssignTypeVisible] = useState(false)
    const [updateassignTypeVisible, setUpdateAssignTypeVisible] = useState(false)
    const [delassignTypeVisible, setDelAssignTypeVisible] = useState(false)

    const [addbookTypeVisible, setAddBookTypeVisible] = useState(false)
    const [updatebookTypeVisible, setUpdateBookTypeVisible] = useState(false)

    const [showMaintenModal, setShowMaintenModal] = useState(false);

    const [bookVisible, setBookVisible] = useState(false)
    const [userVisible, setUserVisible] = useState(false)
    const [bookSearchPreset, setBookSearchPreset] = useState(null);
    const [assignmentSearchPreset, setAssignmentSearchPreset] = useState(null);
    const { book, user } = useContext(Context)

    const userId = user?.user?.id;

    useEffect(() => {
        if (userId) {
            fetchCurrentUserBooks(userId)
                .then(data => {
                    book.setCurrentUserBooks(data);

                })
                .catch(err => console.error("❌ Error:", err));
        }
        fetchGenre().then(data => book.setGenres(data))
        fetchPrices().then(data => book.setPrices(data));
        fetchLanguages().then(data => book.setLanguages(data));
        fetchAssTypes().then(data => book.setAssTypes(data));
    }, [book, userId]);

    const openUserBooksSearch = useCallback((targetUserId) => {
        if (!targetUserId) return;
        setBookSearchPreset({
            ownerId: String(targetUserId),
            nonce: Date.now(),
        });
    }, []);

    const openUserAuthorAssignmentsSearch = useCallback((targetUserId) => {
        if (!targetUserId) return;
        setAssignmentSearchPreset({
            ownerId: String(targetUserId),
            reviewerId: "",
            bookId: "",
            nonce: Date.now(),
        });
    }, []);

    const openUserReviewerAssignmentsSearch = useCallback((targetUserId) => {
        if (!targetUserId) return;
        setAssignmentSearchPreset({
            ownerId: "",
            reviewerId: String(targetUserId),
            bookId: "",
            nonce: Date.now(),
        });
    }, []);

    const openBookAssignmentsSearch = useCallback((targetBookId) => {
        if (!targetBookId) return;
        setAssignmentSearchPreset({
            ownerId: "",
            reviewerId: "",
            bookId: String(targetBookId),
            nonce: Date.now(),
        });
    }, []);

      return (
        <Container fluid className="mt-3">
            <Tabs defaultActiveKey="operations" className="mb-3">
                <Tab eventKey="operations" title="Operations">
            <Row className="mb-2">

                <Col md={12} className="mb-2">
                    <AssignmentSearch
                        externalFilter={assignmentSearchPreset}
                        onOpenBookAssignments={openBookAssignmentsSearch}
                        onOpenUserAuthorAssignments={openUserAuthorAssignmentsSearch}
                        onOpenUserReviewerAssignments={openUserReviewerAssignmentsSearch}
                    />
                </Col>
                {/* Add Genre Category Block */}
            </Row>
            <Row className="mb-2">

                <Col md={12} className="mb-2">
                  <BookSearch
                      externalFilter={bookSearchPreset}
                      onOpenUserBooks={openUserBooksSearch}
                      onOpenBookAssignments={openBookAssignmentsSearch}
                      onOpenUserAuthorAssignments={openUserAuthorAssignmentsSearch}
                      onOpenUserReviewerAssignments={openUserReviewerAssignmentsSearch}
                  />
                </Col>
                {/* Add Genre Category Block */}
            </Row>

            <Row className="mb-2">

                <Col md={12} className="mb-2">
                    <UserSearchAdmin
                        onOpenUserBooks={openUserBooksSearch}
                        onOpenUserAuthorAssignments={openUserAuthorAssignmentsSearch}
                        onOpenUserReviewerAssignments={openUserReviewerAssignmentsSearch}
                    />
                </Col>
                {/* Add Genre Category Block */}
            </Row>

            <Row className="mb-2">

                <Col md={12} className="mb-2">
                    <AdminUserLogs />
                </Col>
                {/* Add Genre Category Block */}
            </Row>

            <Row className="mb-2">

                <Col md={12} className="mb-2">
                    <VirtSellOrdersAdmin  />
                </Col>
                {/* Add Genre Category Block */}
            </Row>

            <Row className="mb-2">

                <Col md={12} className="mb-2">
                    <AffiliatePayoutsAdmin  />
                </Col>
                {/* Add Genre Category Block */}
            </Row>

            <Row className="mb-2">

                <Col md={12} className="mb-2">
                    <AdminVirtTransfersList  />
                </Col>
                {/* Add Genre Category Block */}
            </Row>

            <Row className="mb-2">

                <Col md={12} className="mb-2">
                    <FinStat />
                </Col>
                {/* Add Genre Category Block */}
            </Row>
            <Row className="mb-2">
                <Col md={12} className="mb-2">
            <AffiliateCodeApprove />
                </Col>

            </Row>

            <Row>
                <Col md={2} className="mb-4">
                    <Card className="shadow-sm mt-0 mb-2 bg-light">
                        <Card.Body>
                            <Card.Title className="small">Genre:</Card.Title>
                            <Form>
                                <div className="d-flex justify-content-center gap-3 mt-3">
                                    <Button
                                        variant="success"
                                        className="btn btn-sm"
                                        onClick={() => setAddGenreVisible(true)}
                                    >
                                        Add
                                    </Button>
                                    <Button
                                        variant="primary"
                                        className="btn btn-sm"
                                        onClick={() => setEditGenreVisible(true)}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        variant="danger"
                                        className="btn btn-sm"
                                        onClick={() => setDelGenreVisible(true)}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col md={2} className="mb-4">
                    <Card className="shadow-sm mt-0 mb-2 bg-light">
                        <Card.Body>
                            <Card.Title className="small">Languages:</Card.Title>
                            <Form>
                                <div className="d-flex justify-content-center gap-3 mt-3">
                                    <Button
                                        variant="success"
                                        className="btn btn-sm"
                                        onClick={() => setAddLanguageVisible(true)}
                                    >
                                        Add
                                    </Button>
                                    <Button
                                        variant="primary"
                                        className="btn btn-sm"
                                        onClick={() => setUpdateLanguageVisible(true)}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        variant="danger"
                                        className="btn btn-sm"
                                        onClick={() => setDelLanguageVisible(true)}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                    </Col>
                <Col md={2} className="mb-4">
                    <Card className="shadow-sm mt-0 mb-2 bg-light">
                        <Card.Body>
                            <Card.Title className="small">Prices:</Card.Title>
                            <Form>
                                <div className="d-flex justify-content-center gap-3 mt-3">
                                    <Button
                                        variant="success"
                                        className="btn btn-sm"
                                        onClick={() => setAddPriceVisible(true)}
                                    >
                                        Add
                                    </Button>
                                    <Button
                                        variant="primary"
                                        className="btn btn-sm"
                                        onClick={() => setUpdatePriceVisible(true)}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        variant="danger"
                                        className="btn btn-sm"
                                        onClick={() => setDelPriceVisible(true)}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={2} className="mb-4">
                    <Card className="shadow-sm mt-0 mb-2 bg-light">
                        <Card.Body>
                            <Card.Title className="small">Assignment Type:</Card.Title>
                            <Form>
                                <div className="d-flex justify-content-center gap-3 mt-3">
                                    <Button
                                        variant="success"
                                        className="btn btn-sm"
                                        onClick={() => setAddAssignTypeVisible(true)}
                                    >
                                        Add
                                    </Button>
                                    <Button
                                        variant="primary"
                                        className="btn btn-sm"
                                        onClick={() => setUpdateAssignTypeVisible(true)}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        variant="danger"
                                        className="btn btn-sm"
                                        onClick={() => setDelAssignTypeVisible(true)}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>

                </Col>
                <Col md={2} className="mb-4">
                    <Card className="shadow-sm mt-0 mb-2 bg-light">
                        <Card.Body>
                            <Card.Title className="small">Book Type:</Card.Title>
                            <Form>
                                <div className="d-flex justify-content-center gap-3 mt-3">
                                    <Button
                                        variant="success"
                                        className="btn btn-sm"
                                        onClick={() => setAddBookTypeVisible(true)}
                                    >
                                        Add
                                    </Button>
                                    <Button
                                        variant="primary"
                                        className="btn btn-sm"
                                        onClick={() => setUpdateBookTypeVisible(true)}
                                    >
                                        Edit
                                    </Button>

                                   </div>
                            </Form>
                        </Card.Body>
                    </Card>

                </Col>
                <Col md={2} className="mb-4">
                    <Card className="shadow-sm mt-0 mb-2 bg-light">
                        <Card.Body>
                            <Card.Title className="small">Settings:</Card.Title>
                            <Form>
                                <div className="d-flex justify-content-center gap-3 mt-3">


                                    <Button variant="danger"   className="btn btn-sm" onClick={() => setShowMaintenModal(true)}>
                                        Global Settings
                                    </Button>


                                </div>
                            </Form>
                        </Card.Body>
                    </Card>

                </Col>

            </Row>
            <Row className="mb-2">
                {/*<Col md={6} className="mb-2">*/}
                {/*    <TestEmailSender />*/}
                {/*</Col>*/}

            </Row>
                </Tab>
                <Tab eventKey="public-pages" title="Public Pages">
                    <PublicPageEditorAdmin />
                </Tab>
                <Tab eventKey="public-news" title="Public News/Blog">
                    <AdminPublicNews />
                </Tab>
                <Tab eventKey="rdp-access" title="RDP Access">
                    <AdminRdpAccess />
                </Tab>
                <Tab eventKey="reviewer-profile-requests" title="Reviewer Profile Requests">
                    <AdminReviewerProfileRequests />
                </Tab>
                <Tab eventKey="promotion" title="Promotion">
                    <AdminDashboardPromotion />
                    <div className="mt-3">
                        <AdminPromoBounty />
                    </div>
                </Tab>
                <Tab eventKey="internal-news" title="Internal News">
                    <AdminInternalNews />
                </Tab>
            </Tabs>


            <CreateLanguage show={addlanguageVisible} handleClose={() => setAddLanguageVisible(false)}/>
            <UpdateLanguage show={updatelanguageVisible} handleClose={() => setUpdateLanguageVisible(false)}/>
            <DeleteLanguage show={dellanguageVisible} handleClose={() => setDelLanguageVisible(false)}/>

            <CreateGenre show={addgenreVisible} handleClose={() => setAddGenreVisible(false)}/>
            <EditGenre show={editgenreVisible} handleClose={() => setEditGenreVisible(false)}/>
            <DeleteGenre show={delgenreVisible} handleClose={() => setDelGenreVisible(false)}/>

            <CreatePrice show={addpriceVisible} handleClose={() => setAddPriceVisible(false)}/>
            <UpdatePrice show={updatepriceVisible} handleClose={() => setUpdatePriceVisible(false)}/>
            <DeletePrice show={delPriceVisible} handleClose={() => setDelPriceVisible(false)}/>

            <CreateAssignType show={addassignTypeVisible} handleClose={() => setAddAssignTypeVisible(false)}/>
            <UpdateAssignType show={updateassignTypeVisible} handleClose={() => setUpdateAssignTypeVisible(false)}/>
            <DeleteAssignType show={delassignTypeVisible} handleClose={() => setDelAssignTypeVisible(false)}/>

            <CreateBookType show={addbookTypeVisible} handleClose={() => setAddBookTypeVisible(false)}/>
            <UpdateBookType show={updatebookTypeVisible} handleClose={() => setUpdateBookTypeVisible(false)}/>

            <EditBook show={bookVisible} handleClose={() => setBookVisible(false)}/>
            <EditUser show={userVisible} handleClose={() => setUserVisible(false)}/>

            <MaintenanceModal show={showMaintenModal} handleClose={() => setShowMaintenModal(false)} />
        </Container>
    );
};

export default AdminDashboard;
